module.exports = __webpack_public_path__ + "svg_80x80/gatsby.8e1671.svg";